<template>
    <div class="shadow-lg rounded-lg bg-white">
        <div class="border-b p-4 flex justify-between gap-10 items-center">
            <p class="font-bold text-lg">{{ detail?.reference }}</p>
            <p class="font-bold text-lg"  :class="getStatusClass">{{ statusMap[$i18n.locale][detail?.status] }}</p>
        </div>
        <div class="p-4 flex flex-col gap-4">
            <div v-for="purchase in detail?.purchases" :key="purchase.id" class="flex justify-between">
                <div class="font-bold text-lg">
                    {{ purchase?.service?.name }}
                </div>
                <div class="font-bold text-lg">
                    {{ purchase?.total_price }} TMT
                </div>
            </div>
            <div class="flex justify-between">

                <div class="font-bold text-lg">
                    {{ detail?.date_deposited }}
                </div>
                <div class="font-bold text-lg">
                    {{ bankMap[detail?.bank] }}
                </div>
            </div>

        </div>
        <div class="p-4">
            <button @click="onRemove(detail?.uuid)" class="bg-red-600 text-white font-semibold w-full rounded p-2">{{ $t('page.remove') }}</button>
        </div>


    </div>
</template>

<script>
export default {
    name: "PaymentCard",
    props: {
        detail: {
            type: Object,
            default: {}
        }
    },
    data() {
        return {
            statusMap: {
                tk: {
                    0: 'Ýalňyşlyk',
                    1: 'Garaşylýar',
                    2: 'Tölendi',
                    3: 'Gaýtaryldy'
                },
                ru: {
                    0: 'Ошибка',
                    1: 'Ожидается',
                    2: 'Оплачено',
                    3: 'Возвращено'
                }
            },
            bankMap: {
                0: 'Halk',
                1: 'Rysgal',
                2: 'Senagat',
                3: 'Vnesh'
            }
        }
    },
    methods: {
        onRemove(id) {
            this.$emit('onRemove', id)
        }
    },
    computed: {
        getStatusClass(){
            if (this.detail?.status === 0){
                return 'text-red-500'
            }
            else if (this.detail?.status === 1){
                return 'text-yellow-600'
            }
            else if (this.detail?.status === 2){
                return 'text-green-500'
            }
            else{
                return 'text-main-color'
            }
        }
    }

}
</script>

<style scoped>

</style>